<template>
  <AddFaculty update />
</template>
<script>
import appConfig from '@/app.config'
import AddFaculty from '../../../../components/mooc/tech/faculties/AddFaculty.vue'
export default {
  page: {
    title: 'مدیریت دانشکده',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'mooc-edit-faculties',
  components: {
    AddFaculty,
  },
}
</script>
